module.exports = __webpack_public_path__ + "img/Pista_12.f8a18963.png";